import { ID } from './StandartId';

export const DROPDOWNLIST = {
  MENU_PROFILE: ID.DROPDOWNLIST + "menuprofile",
  REJECT_REASON: ID.DROPDOWNLIST + "menuprofile",
  SELECT: ID.DROPDOWNLIST + "select",
  NOTIFICATION_DATA_TYPE: ID.DROPDOWNLIST + "notificationdatatype",
  NOTIFICATION_COUNTRY_CODE: ID.DROPDOWNLIST + "notificationcountrycode"
};
